import React from 'react';
import { BsLinkedin , BsGithub, BsYoutube } from 'react-icons/bs';
// import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
          <a href="https://www.linkedin.com/in/weizhong-tan-195aa21b4">
            <BsLinkedin />
          </a>
        </div>
        <div>
          <a href="https://www.youtube.com/channel/UC0thsyvziNP9EpD2BEdzHJg">
            <BsYoutube />
          </a>
        </div>
        <div>
          <a href="https://github.com/twz00">
            <BsGithub />
          </a>
        </div>
    </div>
  )
}

export default SocialMedia